// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import $ from 'jquery';
import store from './store/index';
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import 'element-ui/lib/theme-chalk/index.css';
import { Swipe, SwipeItem,Icon,Panel,Collapse, CollapseItem,Popup,Cell, CellGroup,DropdownMenu, DropdownItem} from 'vant';

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Icon)
  .use(Panel)
  .use(Collapse).use(CollapseItem)
  .use(Popup).use(Cell).use(CellGroup)
  .use(DropdownMenu).use(DropdownItem);
Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js